<template>
  <div class="ab-wrap">
    <div class="ab-banner" :style="{backgroundImage: `url(${banner01Icon})`}"></div>
    <div class="ab-content">
      <div class="ab-content-w">
          <div>
            <div class="ab-title">
              <img :src="aboutCompanyIcon" alt="" style="width:300px;height:auto;display:block;margin:0 auto">
            </div>
            <div class="ab-text"> 河北安预信息科技有限公司成立于2016年，是一家专业从事管理咨询及教育培训的机构。公司一直致力于为政府、企业、组织机构等提供具有显性效益的管理咨询服务和一站式在线教育服务平台。通过对在线教育领域的深度挖掘，针对不同的服务对象，提供极具个性特色的定制版整体解决方案，以此来满足用户的全方位需求。</div>
            <div class="ab-text">河北安预信息科技有限公司拥有多项自主研发的应用平台：移动App（IOS/Android）、PC端、HTML5、小程序（微信）等平台，具有独特的企业品牌、专业的服务团队、完整的培训内容以及贴心的售后服务。</div>
         </div>
          <div style="padding-bottom:108px;">
            <div class="ab-title">
              <img :src="anyuOnlineIcon" alt="" style="width:332px;height:auto;display:block;margin:0 auto">
            </div>
            <div class="ab-text">安预在线是河北安预信息科技有限公司旗下自主研发基于SaaS模式的安预在线服务平台和安预在线移动终端等配套工具，为政府、企业、组织机构等提供一站式在线教育服务平台。
            </div>
            <div class="ab-text">平台配备了权威的培训讲师，针对不同层次得培训内容进行差异式教学培训；专业的技术团队进行7×24小时实时监管，同时能针对突发情况及更新情况作出及时的修改更新，保障可持续性得更新迭代，为后台提供强大得支撑保障；具备大数据核心分析技术、通过调研数据可以精准识别培训得重点领域及岗位，继而针对性得进行培训方案得设定。
            </div>
        </div>
        <!--  -->
      </div>
      
    </div>
  </div>
</template>

<script>
import AboutCompanyIcon from "@/assets/aboutcompany.png"
import AnyuOnlineIcon from "@/assets/anyuonline.png"
import Banner01Icon from "@/assets/banner01.png"
export default {
  name: "About",
  data() {
    return {
      aboutCompanyIcon: AboutCompanyIcon,
      anyuOnlineIcon: AnyuOnlineIcon,
      banner01Icon: Banner01Icon,
    };
  },
  components: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ab-wrap{
  width: 100%;
}
.ab-banner{
  width: 100%;
  height: 34.27vw;
  min-height: 659px;
  background-position: center;
  background-size: cover;
}
.ab-banner>img{
  width: 100%;
  height: 658px;
  display: block;
  cursor:pointer;
}
.ab-content{
  width: 100%;
  background-color: #fff;
}
.ab-title{
  padding-top:66px;
  margin-bottom: 44px;
  font-size: 46px;
  text-align: center;
  font-weight: bold;
}
.ab-text{ 
  line-height: 37px;
  text-indent: 2em;
}
.ab-content-w{
  width: 913px;
  margin:0 auto;
  color: #515151;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/abouts.vue